export class Result {
    isSuccess: boolean;
    messageCode: number;
    errorCode: number;
    message:string;
    messageType:string;
    data:any;
    lookupData:any;
}